import {BaseModel} from "@/models/base/BaseModel";
import firebase from "firebase";

export class DocumentCategory extends BaseModel {
  name: string;
  isEnabled: boolean;
  dateTimeCreated: Date | null | firebase.firestore.Timestamp;
  createdByStaffId: string;
  createdByStaffName: string;

  constructor(name, facilityId, createdByStaffId, createdByStaffName) {
    super();
    this.name = name;
    this.facilityId = facilityId;
    this.isEnabled = true;
    this.dateTimeCreated = firebase.firestore.Timestamp.fromDate(new Date());
    this.createdByStaffId = createdByStaffId;
    this.createdByStaffName = createdByStaffName;
  }
}